import { useMutation } from '@tanstack/react-query';
import { pairDevice } from '../services/api';

interface PairDeviceParams {
    userId: string;
    deviceId: string;
    deviceCode: string;
}

export function usePairDevice() {
    return useMutation({
        mutationFn: async (params: PairDeviceParams) => {
            const response = await pairDevice(params);
            // If API returned an error, throw it so the mutation fails
            if (response.__isApiError) {
                throw response;
            }
            return response.data;
        },
    });
}
